import { render } from "./validationComponent.vue?vue&type=template&id=61d9e2fe"
import script from "./validationComponent.vue?vue&type=script&lang=js"
export * from "./validationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__